import actionTypes from "../actionTypes";

export const setShotClassDataAction = (data) => ({
  type: actionTypes.organizeTypes.SHOTCLASS_DATA,
  payload: data,
});
export const setProgramDataAction = (data) => ({
  type: actionTypes.organizeTypes.PROGRAM_DATA,
  payload: data,
});

export const setSeriesShotclassDataAction = (data) => ({
  type: actionTypes.organizeTypes.SERIES_SHOTCLASS_DATA,
  payload: data,
});

export const setClassAndCollectionDataByID = (data) => ({
  type: actionTypes.organizeTypes.GET_CLASS_COLLECTION_DATA,
  payload: data,
});

export const setOrganizeContentDataAction = (data) => ({
  type: actionTypes.organizeTypes.CONTENT_DATA,
  payload: data,
});
